import { h } from './index-662ec80e.js';

const resolveElement = (element) => {
  if (element instanceof HTMLElement)
    return h("div", { innerHTML: element.outerHTML });
  else
    return element;
};
const waitNextRender = (scope) => new Promise(resolve => scope.nextRenderPromises.push(resolve));
const resolveNextRender = (scope) => {
  scope.nextRenderPromises.map(resolve => resolve());
  scope.nextRenderPromises = [];
};
const copyToClipboard = async (text) => await navigator.clipboard.writeText(text);

export { resolveElement as a, copyToClipboard as c, resolveNextRender as r, waitNextRender as w };
